var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 133,
    viewBox: "0 0 132 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12842",
    "data-name": "Group 12842",
    transform: "translate(908 -12626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    cx: 66,
    cy: 66.5,
    rx: 66,
    ry: 66.5,
    transform: "translate(-908 12626)",
    fill: "#fdeebe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hearts",
    transform: "translate(-882.121 12652.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4413",
    "data-name": "Path 4413",
    d: "M45.571,21.71a14.359,14.359,0,0,0-10.322,4.364l-1.316,1.343-1.319-1.343a14.35,14.35,0,0,0-10.32-4.364,13.954,13.954,0,0,0-10.04,4.206,14.909,14.909,0,0,0,.154,20.764L32.586,67.263a1.886,1.886,0,0,0,2.695,0L55.46,46.68a14.909,14.909,0,0,0,.146-20.764A13.944,13.944,0,0,0,45.571,21.71ZM24.028,30.358a7.043,7.043,0,0,0-7.035,7.035,1.618,1.618,0,1,1-3.236,0,10.281,10.281,0,0,1,10.27-10.27,1.617,1.617,0,0,1,0,3.235Z",
    transform: "translate(0 4.767)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4414",
    "data-name": "Path 4414",
    d: "M64.942,12.288A13.556,13.556,0,0,0,55.19,8.2a13.949,13.949,0,0,0-10.027,4.24l-1.28,1.306L42.6,12.44A13.946,13.946,0,0,0,32.577,8.2a13.563,13.563,0,0,0-9.754,4.087,14.223,14.223,0,0,0-3.93,11.5,17.01,17.01,0,0,1,5.705,1.1,8.9,8.9,0,0,1,2.087-8.811,8.19,8.19,0,0,1,5.892-2.466,8.579,8.579,0,0,1,6.161,2.615l1.28,1.307,3.868,3.948,3.865-3.949,1.276-1.3a8.583,8.583,0,0,1,6.164-2.616,8.18,8.18,0,0,1,5.888,2.465,9.043,9.043,0,0,1-.145,12.594l-4.179,4.263a17.357,17.357,0,0,1,1.778,5.916l6.265-6.39A14.484,14.484,0,0,0,64.942,12.288Z",
    transform: "translate(3.772 0)",
    fill: "#4c5b71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/HeartIcon.a20476464bcc81589cd4ca50238878e4.svg";
export { ForwardRef as ReactComponent };